module.exports = __webpack_public_path__ + "img/home-hero.47e25dae.svg";